import {IS_CLIENT, ROOT_ELEMENT_ID} from '../src/common/constant';
import {Page} from '../src/common/constant/page';
import {logOnServer} from '../src/common/function';
import {IKwPage} from '../src/common/type';
import {ApiResultCode} from '../src/common/util/api/apiError';
import {reportErrorSentry} from '../src/common/util/tracking';
import Error404V4 from '../src/commonSub/component/Error404V4';
import Error500 from '../src/commonSub/component/Error500';

interface IProps {
  statusCode?: number;
  errorCode?: number;
}

const ErrorPage: IKwPage<IProps> = ({statusCode, errorCode}) => {
  return (
    <div
      id={ROOT_ELEMENT_ID}
      // 서버에서 정적 파일 생성 시 server-error-detected 문자열 검사로 실패를 탐지한다
      // 따라서 아래 문자열은 임의로 수정하지 말자
      className="h-full server-error-detected"
    >
      {statusCode === 404 ? <Error404V4 /> : <Error500 errorCode={errorCode} />}
    </div>
  );
};

/**
 * 1. HTTP 404, 500에 해당하는 에러는 여기로 들어온다.
 * 2. getInitialProps, render 에서 발생하는 exception은 여기로 들어온다.
 * 위와 같은 에러에 대해서 server 뿐만 아니라 client쪽 에러도 여기로 들어온다.
 */
ErrorPage.getInitialProps = ({res, req, err}) => {
  // res에는 statusCode가 존재한다.
  const statusCode = res
    ? (res as any).statusCode
    : err
      ? err.statusCode
      : null;

  const errorCode =
    err?.message.includes('code=ECONNABORTED') &&
    err?.message.includes('timeout')
      ? ApiResultCode.Timeout
      : undefined;

  if (statusCode !== 404) {
    const error = err || new Error('unknown error');
    reportErrorSentry(error);
    if (!IS_CLIENT) {
      logOnServer({req, msg: err?.message || '', isError: true, err});
    }
  }
  return {statusCode, errorCode};
};

ErrorPage.initialPageProps = {
  page: '_error' as Page,
  getPageTitle: () => 'error',
};

export default ErrorPage;
